import { render, staticRenderFns } from "./leadsHistory.vue?vue&type=template&id=3c66568c&scoped=true"
import script from "./leadsHistory.vue?vue&type=script&lang=js"
export * from "./leadsHistory.vue?vue&type=script&lang=js"
import style0 from "./leadsHistory.vue?vue&type=style&index=0&id=3c66568c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66568c",
  null
  
)

export default component.exports